import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 pl-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-alle",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = { class: "col-12 col-md-12 d-flex align-items-center justify-content-end mt-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-select_pfeil",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = { class: "row list-unstyled mx-auto p-inline-start-0" }
const _hoisted_8 = { class: "d-flex row saal-overview-bearbeiten no-underline align-items-stretch" }
const _hoisted_9 = { class: "col-12 col-md-2 px-0 bg-darker" }
const _hoisted_10 = { class: "col-12 col-md-10 d-flex align-items-center pr-1" }
const _hoisted_11 = { class: "saal-desc p-2" }
const _hoisted_12 = {
  key: 0,
  class: "ml-auto d-flex flex-column flex-md-row text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mb-1 icon-settings_profil_verwalten",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mb-1 icon-datei_bild",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mb-1 icon-kalender",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "ml-auto d-flex flex-column flex-md-row text-center"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mb-1 icon-navigation_pfeil_unten_gross",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_20 = { class: "sr-only" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mb-1 icon-navigation_pfeil_oben_gross",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_23 = { class: "sr-only" }
const _hoisted_24 = {
  key: 0,
  class: "col-12 col-md-12 d-flex align-items-center justify-content-end mt-0 px-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_link_add_element = _resolveComponent("link-add-element")!
  const _component_room_image = _resolveComponent("room-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.roomList.title')), 1)
      ])
    ]),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        _createVNode(_component_link_back, {
          to: "/",
          i18nMessage: "common.backToDashboard",
          class: "mt-0"
        }),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.rooms.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSort())),
                class: "btn btn-link text-positive btn-sortRooms mr-3"
              }, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.room.sortRooms')), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_link_add_element, {
            i18nMessage: "common.room.add",
            to: "/room-add"
          })
        ]),
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "col-12 mb-3"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_room_image, { room: room }, null, 8, ["room"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h2", null, _toDisplayString(room.name), 1),
                    _createElementVNode("p", null, _toDisplayString(room.description), 1)
                  ]),
                  (!_ctx.showSort)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_router_link, {
                          to: { name: 'admin-room-edit', params: { id: room.id }},
                          class: "icon-box d-flex flex-column justify-content-center p-2 m-2"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(room.name), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.room.edit')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: { name: 'admin-room-edit-image', params: { id: room.id }},
                          class: "icon-box d-flex flex-column justify-content-center p-2 m-2"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.room.editImage')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: { name: 'admin-time-slots', params: { id: room.id }},
                          class: "icon-box d-flex flex-column justify-content-center p-2 m-2"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.roomList.configureTimeSlots')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (index < (_ctx.rooms.length -1))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn align-items-center icon-box d-flex flex-column justify-content-center p-2 m-2",
                              onClick: ($event: any) => (_ctx.sortDown(index)),
                              type: "button"
                            }, [
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('common.room.sortRoomsDown')), 1)
                            ], 8, _hoisted_18))
                          : _createCommentVNode("", true),
                        (index > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn align-items-center icon-box d-flex flex-column justify-content-center p-2 m-2",
                              onClick: ($event: any) => (_ctx.sortUp(index)),
                              type: "button"
                            }, [
                              _hoisted_22,
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('common.room.sortRoomsUp')), 1)
                            ], 8, _hoisted_21))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ])
            ]))
          }), 128))
        ]),
        (_ctx.showSort)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSort())),
                class: "btn btn-brand1 px-5",
                type: "button"
              }, _toDisplayString(_ctx.$t('common.room.sortRoomsEnd')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}